module.exports = __webpack_public_path__ + "img/icon-white-7.8e4ec958.svg";